@if (controller.state(); as s) {
<div class="tour-root" [attr.data-fade]="fadeAnimKey()">

  <!-- ── Spotlight / dim ── -->
  @if (!isFreeRoam()) {
    @if (rect) {
      <!-- Dimming barrier with a rounded cutout: one box whose huge outer
           shadow is the dim. Moved with a transform, so following a target
           is a compositor move rather than a full-screen repaint. -->
      <div class="tour-hole"
           [style.transform]="'translate(' + holeX + 'px, ' + holeY + 'px)'"
           [style.width.px]="holeW" [style.height.px]="holeH"
           [style.border-radius.px]="holeR"></div>

      <!-- Animated glow ring around the cutout -->
      <div class="tour-glow"
           [style.transform]="'translate(' + holeX + 'px, ' + holeY + 'px)'"
           [style.width.px]="holeW" [style.height.px]="holeH"
           [style.border-radius.px]="holeR" [style.--tour-accent]="accent()"></div>

      <!-- Interaction-blocking hit-bands around the hole -->
      <div class="tour-hit" [style.left.px]="0" [style.top.px]="0"
           [style.width.px]="viewW" [style.height.px]="holeY"></div>
      <div class="tour-hit" [style.left.px]="0" [style.top.px]="holeY + holeH"
           [style.width.px]="viewW" [style.height.px]="viewH - (holeY + holeH)"></div>
      <div class="tour-hit" [style.left.px]="0" [style.top.px]="holeY"
           [style.width.px]="holeX" [style.height.px]="holeH"></div>
      <div class="tour-hit" [style.left.px]="holeX + holeW" [style.top.px]="holeY"
           [style.width.px]="viewW - (holeX + holeW)" [style.height.px]="holeH"></div>
      @if (blockHole()) {
        <div class="tour-hit" [style.left.px]="holeX" [style.top.px]="holeY"
             [style.width.px]="holeW" [style.height.px]="holeH"></div>
      }
    } @else {
      <!-- Anchor not resolved yet (or authored anchorless): full dim. Blocks
           taps only for a designed full-screen step; otherwise stays passthrough. -->
      <div class="tour-dim-full" [class.block]="isFullScreenStep()"></div>
    }
  }

  <!-- ── Tooltip ── -->
  <div class="tour-tooltip" #tooltip [style.left.px]="tooltipX" [style.top.px]="tooltipY"
       [style.width.px]="tooltipWidth">
    @if (rect && resolvedPlacement === 'bottom') {
      <div class="tour-caret up" [style.transform]="'translateX(' + caretOffset + 'px)'"></div>
    }
    <div class="tour-card" [style.--tour-accent]="accent()">
      <div class="tour-card-head">
        <div class="tour-icon">
          <span class="material-icons">{{ icon() }}</span>
        </div>
        <div class="tour-title">{{ step()?.title }}</div>
        <button class="tour-x" (click)="onClose()" aria-label="Exit tour">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="tour-desc">{{ step()?.description }}</div>
      <div class="tour-foot">
        @if (useBar()) {
          <div class="tour-bar">
            <div class="tour-bar-track"></div>
            <div class="tour-bar-fill" [style.width.%]="barProgress() * 100"></div>
          </div>
          <div class="tour-bar-label">{{ stepIndex() + 1 }}/{{ stepCount() }}</div>
        } @else {
          <div class="tour-dots">
            @for (i of dots(); track i) {
              <span class="dot" [class.active]="i <= stepIndex()" [class.current]="i === stepIndex()"></span>
            }
          </div>
        }
        <div class="tour-nav">
          @if (stepIndex() > 0) {
            <button class="tour-nav-back" (click)="onBack()" aria-label="Back">
              <span class="material-icons">chevron_left</span>
            </button>
          }
          @if (showNext()) {
            <button class="tour-nav-next" (click)="onNext()">{{ nextLabel() }}</button>
          }
        </div>
      </div>
    </div>
    @if (rect && resolvedPlacement === 'top') {
      <div class="tour-caret down" [style.transform]="'translateX(' + caretOffset + 'px)'"></div>
    }
  </div>
</div>
}
